import {
  ApprovalOutlined,
  CancelOutlined,
  DownloadOutlined,
  EditOutlined,
  MailOutline,
  Payment,
  PreviewOutlined,
} from "@mui/icons-material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Menu, MenuItem } from "@mui/material";
import {
  cancelInvoice,
  downloadInvoice,
  submitInvoiceForApproval,
} from "api/services/billing/invoices";
import { snack } from "components/toast";
import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  handleClientChange,
  handleBillingEntityChange,
  handleChange,
  handleUpdateTermsAndConditions
} from "redux/reducers/createReceiptSlice";
import {
  handleChange as cnHandleChange,
  handleFieldChange as cnHandleFieldChange,
  handleResetParticular as cnHandleResetParticular,
  handleExistingParticular as cnHandleExistingParticular,
  handleExistingOtherParticular as cnHandleExistingOtherParticular,
  handleBillingEntityChange as cnHandleBillingEntityChange,
  handlePlaceOfSupplyChange as cnHandlePlaceOfSupplyChange,
  handleClientChange as cnHandleClientChange
} from "redux/reducers/createCreditNoteSlice";
import { TAXES } from "data/taxes";
import { handleError } from "utils/handleError";
import { StyledActionsMenu } from "../styles";
import { EInvoiceStatus, InvoiceStatus } from "../types";
import ViewApprovalStatus from "./ViewApprovalStatus";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";
import { useConfirm } from "context/ConfirmDialog";
import { placeOfSupplyStates } from "data/placeOfSupply";
import { UserProfileContext } from "context/UserProfile";
import { base64ToBlob, checkToken, convertPdfBufferToBase64, SignaturesOnPage, signWithPages, signWithTextPlacement, TextPlacement, TextPosition } from "./siginer";
import { downloadCreditNote } from "api/services/billing/credit-note";
interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: (anchorEl: HTMLElement | null) => void;
  selected: any[];
  clearSelection: () => void;
}

const Actions = (props: Props) => {
  const { anchorEl, setAnchorEl, selected, clearSelection } = props;
  const invoiceIds: number[] = selected.map(i => i.id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { data: uData } = useContext(UserProfileContext);
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Create signature placement for current page
  const signaturePlacement: SignaturesOnPage[] = [
    {
      pageNumber: 1,
      signatures: [
        {
          sign: 1,
          x: 381,
          y: 540,
          width: 123,
          height: 42,
        },
      ],
    },
  ];

  const textPlacement: TextPlacement = {
    pages: [1, 2],
    searchText: 'Authorised Signatory',
    width: 123,
    height: 142,
    position: TextPosition.ABOVE,
    gap: 10
  }

  const { mutate } = useMutation(downloadInvoice, {
    onSuccess: async (res: any) => {
      setIsLoading(false)
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], { type: "application/pdf" });
      const pdf = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = pdf;
      link.download = `${selected[0]?.invoiceNumber} - ${selected[0]?.client?.tradeName || selected[0]?.client ? selected[0]?.client?.displayName : selected[0]?.clientGroup?.displayName}.pdf`;
      link.click();


      //new code
      // const base64Pdf = btoa(
      //   new Uint8Array(res?.data?.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      // );
      // // Define appearance
      // const appearance = {
      //   showTimestamp: true,
      //   showValidityIcon: true,
      //   reason: "I approve this document",
      // };
      // // const result = await signWithPages(
      // //   signaturePlacement,
      // //   base64Pdf,
      // //   appearance
      // // );
      // const result = await signWithTextPlacement(textPlacement, base64Pdf, appearance)
      // if (result.status && result.document?.content) {
      //   const signedPdfBlob = base64ToBlob(result.document.content);

      //   const url = window.URL.createObjectURL(signedPdfBlob);
      //   const link = document.createElement("a");

      //   link.href = url;
      //   link.download = `${selected[0]?.client?.tradeName || selected[0]?.client?.displayName || selected[0]?.clientGroup?.displayName} - ${selected[0]?.invoiceNumber}.pdf`;
      //   document.body.appendChild(link); // Required for Firefox
      //   link.click();
      //   link.remove();

      //   window.URL.revokeObjectURL(url); // Optional cleanup
      // } else {
      //   console.error("Failed to sign PDF:", result.error?.message || "Unknown error");
      // }





    },
    onError: (err: any) => {
      setIsLoading(false)
      snack.error(handleError(err));
    },
  });

  const { mutate: cancel } = useMutation(cancelInvoice, {
    onSuccess: (res: any) => {
      snack.success("Invoice Cancelled");
      clearSelection();
      queryClient.invalidateQueries("invoices");
    },
    onError: (err: any) => {
      console.log(err);
    },
  });

  const { mutate: submit } = useMutation(submitInvoiceForApproval, {
    onSuccess: () => {
      snack.success("Invoice has been submitted for approval");
      clearSelection();
      queryClient.invalidateQueries("invoices");
    },
    onError: (err: any) => {
      console.log(err);
    },
  });

  const handlePriview = () => {
    dispatch(handleClientChange({ client: selected[0].id }))
    window.open(`/billing/invoices/${selected[0]?.id}/preview`);

  };

  const handleDownload = async () => {
    setIsLoading(true)

    // const res = await checkToken();
    // if (!res?.status) {
    //   snack.error(res?.error?.toString() || '');
    //   setIsLoading(false)
    // }


    mutate({ id: selected[0]?.id, userId: uData.id, eSign: true });
  };

  const handleCancel = () => {
    confirm({
      msg: `Are you sure you want to Cancel Invoice Number "${selected[0]?.invoiceNumber}" `,
      action: () => {
        cancel({ id: selected[0]?.id });
      },
    });
  };

  const handleEdit = () => {
    navigate(`/billing/invoices/${selected[0]?.id}/edit`);
  };

  const handleApprovalStatus = () => {
    setOpen(true);
  };

  const handleSubmitForApproval = () => {
    submit({ id: selected[0]?.id });
  };

  const getdisabledStatus = (selected: any) => {
    const selectedclients: any = [];
    selected.forEach((item: any) => {
      if (item?.client?.id) {
        selectedclients.push(item?.client?.id);
      }
      if (item?.clientGroup?.id) {
        selectedclients.push(item?.clientGroup?.id);
      }
    });
    let hasDuplicate = selectedclients.every((val: any, i: any, arr: any) => val === arr[0]);
    if (hasDuplicate) {
      return selected.some(obj => {
        // return obj?.status !== 'PAID' && obj?.status == 'APPROVAL_PENDING'
        return (obj?.status == 'PAID' || obj?.status == 'CANCELLED' || obj?.status === 'SETTLED')
      });
    } else {
      return true;
    }
  }

  return (
    <>
      <StyledActionsMenu
        anchorEl={anchorEl}
        onClick={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <ValidateAccess name={Permissions.EDIT_INVOICE}>
          <MenuItem
            onClick={handleEdit}
            disabled={
              selected.length !== 1 ||
              selected[0]?.status === InvoiceStatus.CANCELLED ||
              selected[0]?.status === InvoiceStatus.PAID ||
              selected[0]?.status === InvoiceStatus.SETTLED ||
              selected[0]?.eInvoiceStatus === EInvoiceStatus.GENERATED ||
              selected[0]?.eInvoiceStatus === EInvoiceStatus.CANCELLED
            }
          >
            <EditOutlined />
            Edit
          </MenuItem>
        </ValidateAccess>
        <ValidateAccess name={Permissions.CREATE_CREDIT_NOTE}>
          {selected.length > 0 &&
            <MenuItem
              onClick={() => {
                const invoice = selected[0];
                const clientId = invoice?.client ? invoice.client.id : invoice?.clientGroup?.id;

                dispatch(cnHandleBillingEntityChange({ billingEntity: invoice?.billingEntity }));
                dispatch(cnHandleChange({ key: 'fromTask', value: true }));
                dispatch(cnHandleChange({ key: 'selectedInvoices', value: [invoice] }));
                dispatch(cnHandleChange({ key: 'totalReceivable', value: invoice?.totalReceivableAmount || 0 }));
                dispatch(cnHandleChange({ key: 'otherParticulars', value: [] }));
                dispatch(cnHandleResetParticular());

                const locationOfSupply = placeOfSupplyStates.find(
                  (o: any) => o.split('-')[1] === invoice?.billingEntity?.locationOfSupply
                ) || '';
                dispatch(cnHandleFieldChange({ key: 'locationOfSupply', value: locationOfSupply }));


                if (invoice?.particulars?.length > 0) {
                  const processedGroups = new Set();
                  invoice.particulars.forEach((data: any) => {
                    if (data.taskItemType === 'MULTIPLE_LINE' && data.groupId) {
                      if (processedGroups.has(data.groupId)) return;
                      processedGroups.add(data.groupId);
                      const groupMembers = invoice.particulars.filter(
                        (p: any) => p.groupId === data.groupId && p.taskItemType === 'MULTIPLE_LINE'
                      );
                      const firstMember = groupMembers[0];
                      const groupParent = {
                        ...firstMember,
                        id: data.groupId,
                        taskItemType: 'MULTIPLE_LINE',
                        taskId: null,
                        name: firstMember.groupName || 'Multiple Tasks',
                        rate: groupMembers.reduce((sum: number, m: any) => sum + Number(m.rate), 0),
                        amount: groupMembers.reduce((sum: number, m: any) => sum + Number(m.amount), 0),
                        tasks: groupMembers.map((m: any) => ({
                          id: m.id,
                          taskId: m.taskId || m.id,
                          taskNumber: m.task?.taskNumber || m.taskNumber || '',
                          taskName: m.task?.name || m.name,
                          actualFee: m.rate,
                          additionalFee: m.additionalexpenditure || 0,
                          status: m.task?.status || m.status,
                          expectedFee: m.task?.feeAmount || m.expectedFee || 0,
                        })),
                      };
                      setTimeout(() => {
                        const tax: any = TAXES.find((tax: any) => tax.value == groupParent?.gst);
                        dispatch(cnHandleExistingParticular({ ...groupParent, gst: tax }));
                      }, 100);
                    } else if (data.taskItemType === 'SINGLE_LINE' && data.task) {
                      setTimeout((i) => {
                        const tax: any = TAXES.find((tax: any) => tax.value == i?.gst);
                        dispatch(cnHandleExistingParticular({
                          ...i, gst: tax,
                          taskNumber: i.task?.taskNumber || i.taskNumber,
                          taskName: i.task?.name || i.name,
                          actualFee: i.rate,
                          additionalFee: i.additionalexpenditure || 0,
                          status: i.task?.status || i.status,
                          expectedFee: i.task?.feeAmount || i.expectedFee || 0,
                          taskItemType: 'SINGLE_LINE',
                        }));
                      }, 100, data);
                    } else {
                      setTimeout((i) => {
                        const tax: any = TAXES.find((tax: any) => tax.value == i?.gst);
                        dispatch(cnHandleExistingParticular({ ...i, gst: tax, taskItemType: null }));
                      }, 100, data);
                    }
                  });
                }

                if (invoice?.otherParticulars?.length > 0) {
                  invoice.otherParticulars.forEach((op: any, index: number) => {
                    setTimeout(() => {
                      dispatch(cnHandleExistingOtherParticular({
                        id: op.id,
                        index,
                        key: op.name,
                        value: op.amount,
                        taskExpenseType: op.taskExpenseType || 'PURE_AGENT',
                      }));
                    }, 150);
                  });
                }

                setTimeout(() => {
                  dispatch(cnHandleFieldChange({ key: 'hasTds', value: invoice?.hasTds }));
                  dispatch(cnHandleFieldChange({ key: 'tdsView', value: invoice?.tdsView }));
                  dispatch(cnHandleFieldChange({ key: 'tdsSection', value: invoice?.tdsSection }));
                  dispatch(cnHandleFieldChange({ key: 'tdsRate', value: invoice?.tdsRate }));
                  // GST TDS is inherited from the invoice (read-only on credit note, like IT TDS)
                  dispatch(cnHandleFieldChange({
                    key: 'hasGstTds',
                    value: !!(invoice?.hasGstTds ?? (invoice?.gstTdsIgst || invoice?.gstTdsCgst || invoice?.gstTdsSgst)),
                  }));
                }, 100);

                setTimeout(() => {
                  if (invoice.placeOfSupply) {
                    dispatch(cnHandlePlaceOfSupplyChange(invoice.placeOfSupply))
                  }
                }, 3000);

                setTimeout(() => {
                  dispatch(cnHandleChange({ key: 'client', value: clientId }));
                  dispatch(cnHandleClientChange({ client: invoice?.client ? invoice.client : invoice?.clientGroup }));
                }, 2000);

                navigate(`/billing/credit-note/add`);
              }
              }
              disabled={selected.length !== 1 || getdisabledStatus(selected)}
            >
              <Payment />
              Create Credit Note
            </MenuItem>
          }
        </ValidateAccess>
        <ValidateAccess name={Permissions.INVOICE_RECEIPT_PAYMENT}>
          {selected.length > 0 &&
            <MenuItem
              onClick={() => {
                dispatch(handleChange({ key: 'fromInvoice', value: true }));
                dispatch(handleChange({ key: 'invoiceIds', value: invoiceIds }));
                dispatch(handleBillingEntityChange({ billingEntity: selected[0]?.billingEntity }));
                dispatch(handleChange({ key: 'logoUrl', value: selected[0]?.billingEntity?.logStorage?.fileUrl }))
                dispatch(handleChange({ key: 'signatureUrl', value: selected[0]?.billingEntity?.signatureStorage?.fileUrl }));
                const locationOfSupply = placeOfSupplyStates.find((o: any) => o.split('-')[1] === selected[0]?.billingEntity?.locationOfSupply);
                dispatch(handleChange({ key: "locationOfSupply", value: locationOfSupply || "" }));
                dispatch(handleChange({ key: "terms", value: selected[0]?.billingEntity.creditPeriod || null }));
                dispatch(handleChange({ key: 'selectedInvoicesInInv', value: [selected[0]?.id] }));

                setTimeout(() => {
                  dispatch(handleChange({ key: 'client', value: selected[0]?.client ? selected[0]?.client.id : selected[0]?.clientGroup?.id }));
                  dispatch(handleClientChange({ client: selected[0]?.client ? selected[0]?.client : selected[0]?.clientGroup }));
                }, 2000);

                navigate(`/billing/receipts/add`)
              }
              }
              disabled={getdisabledStatus(selected) || selected?.[0]?.clientGroup}
            >
              <Payment />
              Create Payment Receipt
            </MenuItem>
          }
        </ValidateAccess>
        <ValidateAccess name={Permissions.PREVIEW_INVOICE}>

          <MenuItem
            disabled={
              selected.length !== 1
            }
            onClick={() => handlePriview()}
          >
            <PreviewOutlined />
            Preview
          </MenuItem>
        </ValidateAccess>
        <ValidateAccess name={Permissions.DOWNLOAD_INVOICE}>

          <MenuItem
            onClick={handleDownload}
            disabled={
              selected.length !== 1 ||
              isLoading
            }
          >
            <DownloadOutlined />
            Download
          </MenuItem>
        </ValidateAccess>
        <ValidateAccess name={Permissions.CANCEL_INVOICE}>
          <MenuItem
            onClick={handleCancel}
            disabled={
              selected.length !== 1 ||
              selected[0]?.status === InvoiceStatus.CANCELLED ||
              selected[0]?.status === InvoiceStatus.PAID ||
              selected[0]?.status !== InvoiceStatus.APPROVAL_PENDING ||
              selected[0]?.eInvoiceStatus === EInvoiceStatus.GENERATED
            }
          >
            <CancelOutlined />
            Cancel
          </MenuItem>
        </ValidateAccess>
      </StyledActionsMenu>
      <ViewApprovalStatus
        open={open}
        setOpen={setOpen}
        invoiceId={selected[0]?.id}
      />
    </>
  );
};

export default Actions